module.exports = __webpack_public_path__ + "static/media/phone.1f1e1b37.svg";